export { default as RewardsManagement } from './rewards-management';
